var lookup = {

	init: function () {

		$('.m-postcode-lookup:not(.js-lookup-done)').each(function () {
			var wrapper = $(this);
			var form = wrapper.closest('form');
			var input = form.find('.js-lookup-postcode');
			var groupSearch = form.find('.js-lookup-fields');
			var groupAddress = groupSearch.next('.js-address-fields:first');
			var groupCountry = form.find('.js-lookup-country');
			var manual = groupSearch.find('.js-lookup-trigger-manual');

			// check if we have an address already
			if (!groupAddress.find('.js-address-line-1').val()) {
				groupSearch.show();
				groupAddress.hide();
				// init autocomplete
				input.autocomplete({
					minLength: 2,
					source: function (request, response) {
						lookup.search(input, form, request, response, manual);
					},
					select: function (event, ui) {
						lookup.select(input, form, event, ui, manual);
					}
				}).attr('autocomplete', 'autocomplete_off');
			}
			else {
				lookup.manual(groupSearch, groupAddress);
			}

			// region check
			groupCountry.on('change', function () {
				if (parseInt(groupCountry.find(':selected').attr('data-region-count'), 10) < 1) {
					form.find('.js-region-group').hide();
				}
				else {
					form.find('.js-region-group').show();
				}
			});
			groupCountry.change();

			// manual trigger
			manual.off('click').on('click', function () {
				// clear postcode
				input.val('');
				// clear address
				lookup.clear(groupAddress, groupCountry);
				// show address
				groupAddress.show();
				// scroll
				if (Modernizr.mq('(max-width: ' + (site.bp.tabletLarge - 1) + 'px')) {
					site.scrollTo(groupAddress.offset().top, 250);
				}
				return false;
			});

			// form submission check
			form.data('validator').settings.invalidHandler = function () {
				lookup.manual(groupSearch, groupAddress);
			};

			form.data('validator').settings.submitHandler = function (form) {
				lookup.manual(groupSearch, groupAddress);
				if (form.valid()) {
					form.submit();
				}
			};

			// done
			wrapper.addClass('js-lookup-done');
		});

	},

	clear: function (address, country) {
		// reset fields
		address.find('.js-address-company, .js-address-line-1, .js-address-line-2, .js-address-line-3, .js-address-town, .js-address-county, .js-address-region, .js-address-postcode').val('');
		// check region
		country.change();
	},

	search: function (input, form, request, response, manual) {
		$.ajax({
			url: input.attr('data-find-url') || '/postcode/addresses',
			data: {
				term: request.term,
				countryId: form.find('.js-lookup-country').val(),
				lastId: input.lastId
			},
			cache: false,
			success: function (data) {
				var items = [];
				for (var i = 0; i < data.length; i++) {
					items.push({ value: data[i].Text, label: data[i].Text, next: data[i].Next, id: data[i].Id });
				}
				response(items);
			},
			error: function (e) {
				// show notice
				popups.confirm('Search error', 'Sorry, something went wrong: <i>' + e.statusText.toLowerCase() + '</i>.<br />Add your address manually, or contact us if the problem continues.', '', true);
				// disable input
				//input.attr('disabled', 'disabled');
				// manual
				manual.click();
			}
		});
	},

	select: function (input, form, event, ui, manual) {
		if (ui.item.next === 'Find') {
			input.lastId = ui.item.id;
			setTimeout(function () {
				input.autocomplete('search', ui.item.value);
			}, 1);
		}
		else {
			$.ajax({
				url: input.attr('data-retrieve-url'),
				data: {
					id: ui.item.id
				},
				success: function (data) {
					// show address
					var groupAddress = input.closest('.js-lookup-fields').hide().next('.js-address-fields:first');
					groupAddress.show();

					// populate fields
					groupAddress.find('.js-address-company').val(data.Company);
					groupAddress.find('.js-address-line-1').val(data.Address1);
					groupAddress.find('.js-address-line-2').val(data.Address2);
					groupAddress.find('.js-address-line-3').val(data.Address3);
					groupAddress.find('.js-address-town').val(data.Town);
					groupAddress.find('.js-address-postcode').val(data.Postcode);
					groupAddress.find('.js-address-county').val(data.County);

					// country
					if (data.Country != null && data.Country != 'undefined') {
						var country = form.find('.js-lookup-country');
						country.val(data.Country.Id);

						var region = groupAddress.find('.js-address-region');
						var regionGroup = region.closest('.js-region-group');
						if (data.Country.RegionCount != null && data.Country.RegionCount != 'undefined') {
							if (parseInt(data.Country.RegionCount, 10) > 0) {
								regionGroup.show();
							}
							else {
								regionGroup.hide();
							}
						}
						else {
							regionGroup.hide();
						}
					}

				},
				error: function (e) {
					// show notice
					popups.confirm('Search error', 'Sorry, something went wrong: <i>' + e.statusText.toLowerCase() + '</i>.<br />Add your address manually, or contact us if the problem continues.', '', true);
					// disable input
					//input.attr('disabled', 'disabled');
					// manual
					manual.click();
				}
			});
		}
	},

	manual: function (search, address, hideSearch) {
		search.hide();
		address.show();
	}

};

$(function () {
	lookup.init();
	site.doc.ajaxComplete(function () {
		lookup.init();
	});
});